<template lang="pug">
  v-container
    add-option-dialog(v-model="addOptionDialog" :productId="$route.params.productID")
    delete-dialog(v-model="deleteOptionDialog" @confirm="deleteOption")
    v-row
      v-col
        v-btn(block color="orange" @click="addOptionDialog = true") Add Option
    v-row(justify="center")
      v-col(cols="12")
        v-card(v-for="(option, index) in options" :class="{'mb-6': options.length > 1}")
          v-card-title
            v-row
              v-col
                p.mb-1.subtitle-1
                  v-chip.mr-2.yellow.black--text.font-weight-black(small) {{ option.id }}
                  v-chip.mr-2.yellow.black--text.font-weight-black(small) {{ option.provider | providerView }}
                  | Provider Title : {{ option.original_title }}
              v-col.shrink
                v-btn(icon @click="markDeleteOption = option; deleteOptionDialog = true")
                  v-icon mdi-trash-can
          v-card-text
            v-row.mb-3(align="center")
              v-col.py-0(cols="4")
                v-text-field(v-model="option.title" label="Title" hide-details)
              v-col.py-0(cols="2")
                v-text-field(v-model="option.unit_name_singular" label="Unit Name (Singular)" placeholder="pax, vehicle.." hide-details)
              v-col.py-0(cols="2")
                v-text-field(v-model="option.unit_name_plural" label="Unit Name (Plural)" placeholder="pax, vehicles.." hide-details)
              v-col.py-0(cols="4")
                v-select(v-model="option.clazz" label="Class" :items="clazz" item-text="title" item-value="id" hide-details)
            v-row.mb-3(align="center")
              v-col.py-0(cols="4")
                v-text-field(v-model="option.cost_price" label="Cost Price" prefix="RM" readonly hide-details)
              v-col.py-0(cols="4")
                v-text-field(v-model="option.sell_price" label="Sell Price" prefix="RM" type="number" step="0.01" hide-details)
              v-col.py-0(cols="4")
                v-text-field(v-model="option.normal_price" label="Normal Price" prefix="RM" type="number" step="0.01" hide-details)
            v-row.mb-3(align="center")
              v-col.py-0(cols="2")
                v-text-field(v-model="option.validity" label="Validity" suffix="Days" type="number" hide-details)
              v-col.py-0(cols="2")
                v-text-field(v-model="option.booking_before" label="Booking Before" suffix="Days" type="number" hide-details)
              v-col.py-0(cols="4")
                v-select(v-model="option.close_day" label="Day Close" :items="days" item-text="name" item-value="idx" hide-details clearable multiple)
              v-col.py-0(cols="4")
                date-picker(:pickDate="option.close_date" label="Date Close" @pick="option.close_date = $event")
    v-footer(v-if="options.length > 0" app inset padless color="transparent")
      v-row(justify="center")
        v-col(cols="8" style="background-color: #424242")
          v-row(justify="center")
            v-col.py-0(cols="8")
              v-btn(block color="success" @click="saveOption" :disabled="!$store.state.groups.includes('Production')") Save Option
              span.caption.warning--text(v-if="!saveEnabled") Warning: Currently being edited by other user
</template>

<script>
import DatePicker from '@/components/DatePicker'
import AddOptionDialog from '@/components/AddOptionDialog'
import DeleteDialog from '@/components/DeleteDialog'

export default {
  name: 'OptionTab',
  components: { DatePicker, AddOptionDialog, DeleteDialog },
  props: ['language', 'refresh', 'saveEnabled'],
  data: () => ({
    addOptionDialog: false,
    deleteOptionDialog: false,
    markDeleteOption: null,
    options: [],
    clazz: [],
    days: [
      { name: 'Sunday', idx: 0 },
      { name: 'Monday', idx: 1 },
      { name: 'Tuesday', idx: 2 },
      { name: 'Wednesday', idx: 3 },
      { name: 'Thursday', idx: 4 },
      { name: 'Friday', idx: 5 },
      { name: 'Saturday', idx: 6 }
    ],
    check: 0,
    opt_check: 0
  }),
  computed: {
    data_length () {
      let count = 0
      this.options.forEach(o => {
        if (o.close_day) {
          count = count + o.close_day.length
        }
        if (o.close_date) {
          count = count + o.close_date.length
        }
      })
      return count
    }
  },
  watch: {
    refresh (val) {
      if (val === true) {
        setTimeout(() => {
          this.fetchOptions()
          this.fetchClazz()
        }, 200)
      }
    },
    check (val) {
      if (this.data_length > 0) {
        if (val === this.data_length) {
          this.$alert.success('Save Close Rule Successful')
          this.check = 0
          this.fetchOptions()
          this.fetchClazz()
        }
      }
    },
    opt_check (val) {
      if (this.options.length === val) {
        this.$alert.success('Save Option Successful')
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.fetchOptions()
      this.fetchClazz()
    }, 200)
  },
  methods: {
    fetchOptions () {
      let id = this.$route.params.productID
      this.$axios.get(`/options/?product=${id}&locale=${this.language}`)
        .then(resp => {
          this.options = [
            ...resp.data.results.map(o => {
              return {
                id: o.id,
                original_title: o.original_title,
                title: o.title,
                unit_name_singular: o.unit_name_singular,
                unit_name_plural: o.unit_name_plural,
                product: o.product.id,
                provider: o.provider,
                clazz: o.clazz,
                normal_price: this.senToRM(o.normal_price),
                cost_price: this.senToRM(o.cost_price),
                sell_price: this.senToRM(o.sell_price),
                validity: o.validity,
                booking_before: o.booking_before
              }
            })
          ]
          this.options.forEach(o => {
            this.$axios.get(`/closerule/`, { params: { option: o.id, date__isnull: true, page_size: '-1' } })
              .then(resp => {
                if (resp.data.results.length > 0) {
                  this.$set(o, 'closerule_day', [ ...resp.data.results ])
                  this.$set(o, 'close_day', [ ...resp.data.results.map(a => { return a.day_of_week }) ])
                }
              })
            this.$axios.get(`/closerule/`, { params: { option: o.id, date__isnull: false, page_size: '-1' } })
              .then(resp => {
                if (resp.data.results.length > 0) {
                  this.$set(o, 'closerule_date', [ ...resp.data.results ])
                  this.$set(o, 'close_date', [ ...resp.data.results.map(a => { return a.date }) ])
                }
              })
          })
          this.$emit('afterRefresh', false)
        })
    },
    fetchClazz () {
      let id = this.$route.params.productID
      this.$axios.get(`/clazzs/?product=${id}&locale=${this.language}`)
        .then(resp => {
          this.clazz = [...resp.data.results]
        })
    },
    removeFeatures (item, ind) {
      const index = this.options[ind].features.indexOf(item.id)
      if (index >= 0) this.options[ind].features.splice(index, 1)
    },
    senToRM (val) {
      return (parseFloat(val)/100).toFixed(2)
    },
    RMtoSen (val) {
      return (parseFloat(val)*100)
    },
    saveOption () {
      this.check = 0
      this.opt_check = 0
      this.options.forEach(o => {
        let data = {
          title: o.title,
          sell_price: this.RMtoSen(o.sell_price),
          normal_price: this.RMtoSen(o.normal_price),
          clazz: o.clazz,
          validity: o.validity,
          booking_before: o.booking_before,
          unit_name_singular: o.unit_name_singular,
          unit_name_plural: o.unit_name_plural
        }
        this.$axios.patch(`/options/${o.id}/`, data)
          .then(resp => {
            this.opt_check++
          })
          .catch(error => {
            console.log(error)
          })
        if (o.close_day) {
          if (o.close_day.length > 0) {
            // this.data_length = this.data_length + o.close_day.length
            if (o.closerule_day) {
              o.close_day.forEach(cd => {
                if (!o.closerule_day.map(m => { return m.day_of_week }).includes(cd)) {
                  // post close_day
                  this.$axios.post('/closerule/', { day_of_week: cd, date: null, option: o.id })
                    .then(() => {
                      this.check++
                    })
                } else {
                  //do nothing
                  this.check++
                }
              })
              o.closerule_day.forEach(c => {
                if (!o.close_day.includes(c.day_of_week)) {
                  // delete unused data in api
                  this.$axios.delete(`/closerule/${c.id}/`)
                } else {
                  //do nothing
                }
              })
            } else {
              o.close_day.forEach(c => {
                this.$axios.post('/closerule/', { day_of_week: c, date: null, option: o.id })
                  .then(() => {
                    this.check++
                  })
              })
            }
          } else {
            if (o.closerule_day) {
              o.closerule_day.forEach(c => {
                this.$axios.delete(`/closerule/${c.id}/`)
              })
            }
          }
        }

        if (o.close_date) {
          if (o.close_date.length > 0) {
            // this.data_length = this.data_length + o.close_date.length
            if (o.closerule_date) {
              o.close_date.forEach(cd => {
                if (!o.closerule_date.map(m => { return m.date }).includes(cd)) {
                  // post close_date
                  this.$axios.post('/closerule/', { day_of_week: null, date: cd, option: o.id })
                    .then(() => {
                      this.check++
                    })
                } else {
                  //do nothing
                  this.check++
                }
              })
              o.closerule_date.forEach(c => {
                if (!o.close_date.includes(c.date)) {
                  // delete unused data in api
                  this.$axios.delete(`/closerule/${c.id}/`)
                } else {
                  //do nothing
                }
              })
            } else {
              o.close_date.forEach(c => {
                this.$axios.post('/closerule/', { day_of_week: null, date: c, option: o.id })
                  .then(() => {
                    this.check++
                  })
              })
            }
          } else {
            if (o.closerule_date) {
              o.closerule_date.forEach(c => {
                this.$axios.delete(`/closerule/${c.id}/`)
              })
            }
          }
        }
      })
      this.$emit('save')
    },
    deleteOption () {
      this.$axios.delete(`/options/${this.markDeleteOption.id}/`)
        .then(resp => {
          this.$showAlert('success', 'Delete option success!')
        })
        .catch(error => {
          this.$showAlert('error', 'Delete option fail! Try removing this option from default option in Product Page and Class first.')
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>